import React from 'react';
import PropTypes from 'prop-types';
import { Disclosure } from '@headlessui/react';
import classNames from 'classnames';
import ChevronDownIcon from 'components/v2/icons/ChevronDownIcon';
import ChevronRightIcon from 'components/v2/icons/ChevronRightIcon';

export default function CollapsibleItem({
  text,
  renderTitle,
  className,
  children,
  defaultOpen,
  disclosureButtonClassName,
  hideIcon,
  dataTestId
}) {
  return (
    (<Disclosure defaultOpen={defaultOpen}>
      {({ open }) => (
        <div data-testid={dataTestId} className={classNames(className)}>
          <Disclosure.Button
            data-testid="undefined-a59a528d"
            className={classNames(
              'flex items-center justify-between w-full',
              disclosureButtonClassName,
            )}>
            {text && (
              <span data-testid="span-e694070c" className="text-sm text-gray-700 font-medium">{text}</span>
            )}
            {renderTitle && renderTitle(open)}
            {open && !hideIcon && <ChevronDownIcon className="w-4 h-4" />}
            {!open && !hideIcon && <ChevronRightIcon className="w-4 h-4" />}
          </Disclosure.Button>
          <Disclosure.Panel data-testid="undefined-06e368ff">{children}</Disclosure.Panel>
        </div>
      )}
    </Disclosure>)
  );
}

CollapsibleItem.propTypes = {
  text: PropTypes.string,
  renderTitle: PropTypes.func,
  defaultOpen: PropTypes.bool,
  hideIcon: PropTypes.bool,
};

CollapsibleItem.defaultProps = {
  defaultOpen: false,
  hideIcon: false,
};
